import React from "react";
import { useLiveEdit } from "../lib/liveEdit";
import SectionSlot from "../components/live/SectionSlot";
import SectionAdder from "../components/live/SectionAdder";

export default function Home() {
  const { sections } = useLiveEdit();
  const order = sections.order;
  return (
    <>
      {order.map((key, i) => (
        <SectionSlot
          key={key}
          sectionKey={key}
          index={i}
          total={order.length}
        />
      ))}
      <SectionAdder />
    </>
  );
}
